import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-29",
  "use": "icon-button_icon-29-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-29\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M9 8l3 3M15 8l-3 3M9 14.5h6M9 11.5h6M12 11.4v6M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2c-2.379 0-4.564.83-6.28 2.218-.436.352-.841.74-1.212 1.158M3.508 6.376h3M3.342 3.289v3.087\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol